// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { IfFeature } from '@tectonics/prs/feature';
import { TipMessage } from './tip-message';
import { BankList } from './bank-list';
import { Separator } from '../../../../atoms';

export function TefForm(): Node {
  const allFeatures = useAllFeatures();

  return (
    <Root>
      <IfFeature allFeatures={allFeatures} wanted="field_tef_select_bank">
        <TipMessage />
        <Separator direction="v" size={3} />
        <BankList />
      </IfFeature>
    </Root>
  );
}


const Root = styled.div``;
